import React from 'react';
import ReactDOM from 'react-dom/client';
import Paper2CodeApp from './Paper2CodeApp.jsx';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <Paper2CodeApp />
  </React.StrictMode>,
);
